app.service('creditCalculationsService', [ 'CONSTANTS', 'portalHelper',
  function (CONSTANTS, portalHelper) {
    const service = this;

    /***
     * Calculates the various charges depending on the base fielding charges and
     * @param {number} fieldingCharges int
     * The fielding charges to base the calculations on
     *
     * @param {boolean} waiveMinCharges
     * Whether we should waive the minimum charges or not
     *
     * @returns {object} result
     * result = {
     *  // minimum charges for different aspects of a survey (depending on waiveMinCharges flag)
     *  min_charges: {
     *    question_development: {number},
     *    background_material: {number},
     *    insight_report: {number}
     *  },
     *  // total charges for different aspects of a survey (includes comparison with min charges)
     *  total_charges: {
     *    question_development: {number},
     *    background_material: {number},
     *    insight_report: {number},
     *    total: {number}    // total of all the charges estimated for a survey
     *  },
     *  remainder_charges: {
     *    question_development: {number}   // Remainder of charges after considering min charges
     *  }
     * };
     */
    service.calculate_charges = function (fieldingCharges, waiveMinCharges) {
      const qdPercentage = 0.15;
      const bmPercentage = 0.10;
      const irPercentage = 0.25;

      const result = {
        min_charges: {
          question_development: CONSTANTS.minCharges.QUESTION_DEVELOPMENT,
          background_material: CONSTANTS.minCharges.BACKGROUND_MATERIAL_DEVELOPMENT,
          insight_report: CONSTANTS.minCharges.INSIGHT_REPORT
        },
        total_charges: {
          question_development: 0,
          background_material: 0,
          insight_report: 0,
          total: 0
        },
        remainder_charges: {
          question_development: 0
        }
      };

      if (waiveMinCharges == true) {
        result.min_charges.question_development = 0;
        result.min_charges.background_material = 0;
        result.min_charges.insight_report = 0;
      }

      // Calculating total charges
      result.total_charges.question_development =
        Math.max(
          portalHelper.bankersRounding(fieldingCharges * qdPercentage, 0),
          result.min_charges.question_development);

      result.remainder_charges.question_development =
        Math.max((result.total_charges.question_development - result.min_charges.question_development), 0);

      result.total_charges.background_material =
        Math.max(
          portalHelper.bankersRounding(fieldingCharges * bmPercentage, 0),
          result.min_charges.background_material);

      result.total_charges.insight_report =
        Math.max(
          portalHelper.bankersRounding(fieldingCharges * irPercentage, 0),
          result.min_charges.insight_report);

      result.total_charges.total = fieldingCharges +
        result.total_charges.question_development +
        result.total_charges.background_material +
        result.total_charges.insight_report;

      return result;
    };

    /***
     * Calculates the total charges for a survey based on the flags passed in
     * like question_development, prepare_background, share_report
     *
     * @param {object} survey_details
     *
     * @returns {number} Total charges for a survey based on flag
     */
    service.calculate_charges_based_on_flags = function (survey_details) {
      const result = service.calculate_charges(survey_details.fielding_charge, survey_details.waive_minimum_charges);

      let total = survey_details.fielding_charge;
      if (survey_details.question_development) {
        total += result.total_charges.question_development;
      }

      if (survey_details.prepare_background) {
        total += result.total_charges.background_material;
      }

      if (survey_details.share_report) {
        total += result.total_charges.insight_report;
      }

      return total;
    };
    /***
     * Calculates the total amount from the manual adjustments returned in the survey/all/details
     * end point.
     *
     * @param {object[]} manualAdjustments
     *
     * @returns {number} Summation of manual adjustment charges
     */
    service.calculate_additional_charges = function (manualAdjustments) {
      if (manualAdjustments == null || manualAdjustments.length == 0) {
        return 0;
      }

      return _.reduce(
        manualAdjustments,
        function(memo, charge) {
          return memo + charge.amount; }, 0);
    };

    /***
     * Given a list of milestones, calculates the delivered charges from it
     *
     * @param {object[]} milestones
     *
     * @returns {number} Summation of delivered charges
     */
    service.calculate_delivered_charges = function (milestones) {
      const deliveredMilestone = _.findWhere(milestones,
        { code_name: CONSTANTS.surveyMilestones.DELIVERED });

      if (deliveredMilestone != undefined &&
        deliveredMilestone.charges != null &&
        deliveredMilestone.charges.length > 0) {

        return _.reduce(
          deliveredMilestone.charges,
          function (memo, charge) {
            return memo + charge.committed_amount;
          }, 0);
      }

      return 0;
    };
  }]);
